import * as React from "react";
import classNames from "classnames";

import { Typography, Switch, withStyles } from "@material-ui/core";

const styles = (theme) => ({
  container: {
    height: "40px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "#363637",
    marginBottom: "1px",
    "&:hover": {
      backgroundColor: "#464646",
    },
    transition: "all 0.3s ease-in",
  },
  switchColor: {
    color: "#1b1b1b",
  },
  description: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 400,
    color: "rgba(255,255,255,0.87)",
    whiteSpace: "nowrap" as any,
    width: "calc(100% - 78px)",
    overflow: "hidden",
  },
  colorSwitchBase: {
    color: "#dedede",
    "&$colorChecked": {
      color: "#ABC200",
      "& + $colorBar": {
        backgroundColor: "#ABC200",
      },
    },
  },
  colorBar: {},
  colorChecked: {
    color: "#ABC200",
  },
  fontDisabled: {
    color: "rgba(255, 255, 255, 0.3)",
  },
});

interface ISwitchProps {
  value: string;
  checked: boolean;
  onChange: any;
}

type IProps = {
  switchProps: ISwitchProps;
  description: string;
  classes: any;
};

function RateLibrary(props: IProps) {
  const { classes, switchProps, description } = props;
  return (
    <div className={classes.container}>
      <Switch
        {...switchProps}
        color={"primary"}
        classes={{
          colorPrimary: classes.switchColor,
          switchBase: classes.colorSwitchBase,
          bar: classes.colorBar,
          checked: classes.colorChecked,
        }}
      />
      <Typography
        component="span"
        className={classNames(classes.description, {
          [classes.fontDisabled]: !switchProps.checked,
        })}
      >
        {description}
      </Typography>
    </div>
  );
}

export default withStyles(styles)(RateLibrary);



// WEBPACK FOOTER //
// ./src/modules/activitySearch/components/layouts/RateLibrary.tsx